export const getIsEmailValid = (email: string): boolean => {
  return /\S+@\S+\.\S+/.test(email);
};
